const state = () => ({
  statusCreateMails: false,
  actionCreateMails: false,
  statusDeleteMails: false,
  actionDeleteMails: false,
});

const getters = {};

const actions = {
  setStatusMails({ commit }, isCreate) {
    commit("setStatusMails", { status: isCreate });
  },
  setActionMails({ commit }, isAction) {
    commit("setActionMails", { status: isAction });
  },
  setStatusDeleteMails({ commit }, isDelete) {
    commit("setStatusDeleteMails", { status: isDelete });
  },
  setActionDeleteMails({ commit }, isAction) {
    commit("setActionDeleteMails", { status: isAction });
  },
};

const mutations = {
  setStatusMails(state, { status }) {
    state.statusCreateMails = status;
  },
  setActionMails(state, { status }) {
    state.actionCreateMails = status;
  },
  setStatusDeleteMails(state, { status }) {
    state.statusDeleteMails = status;
  },
  setActionDeleteMails(state, { status }) {
    state.actionDeleteMails = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
